import { DealerApiClient, DealerPlacementIds } from '@wix/package-picker-sdk';
import { getSearchParams, Vertical } from '@wix/package-picker-shared';
import {
  eclipseServerData,
  useAnonymous,
} from '@wix/package-picker-shared-eclipse';
import { usePremiumEssentialsContext } from '@wix/premium-fed-sdk/@premium-essentials';

interface UseDealerIntentParams {
  isUpgradeFlow: boolean;
  enabled?: boolean;
}

interface UseDealerIntentResult {
  intent: Vertical | undefined;
  title: string | undefined;
  isLoading: boolean;
}

export const useDealerIntent = ({
  isUpgradeFlow,
  enabled = true,
}: UseDealerIntentParams): UseDealerIntentResult => {
  const { httpClient } = usePremiumEssentialsContext();
  const { isAnonymous } = useAnonymous();
  const { siteGuid } = getSearchParams();

  const placementId = isUpgradeFlow
    ? DealerPlacementIds.APP_INTENT_SECOND_UPGRADE
    : DealerPlacementIds.APP_INTENT_INITIAL_PURCHASE;
  const { siteAuthorizationType } = eclipseServerData.get();

  const shouldFetch = enabled && !!httpClient && !isAnonymous && !!siteGuid;

  const dealerIntentQuery = DealerApiClient.hooks.useGetDealerIntent(
    {
      placementId,
      siteId: siteGuid,
      siteAuthorizationType,
    },
    shouldFetch,
  );

  return {
    intent: dealerIntentQuery.data?.intent,
    title: dealerIntentQuery.data?.title,
    isLoading: dealerIntentQuery.isLoading,
  };
};
